/* eslint-disable react/prop-types */
import Box from "@material-ui/core/Box";
import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import "../assets/css/HistoricList.css";
import lod_ from "lodash";
import ChannelUserInfoMembershipDisplayer from "./../helpers/ChannelUserInfoMembershipDisplayer";
import MessageItem from "../pages/Cockpit/Message/MessageItem";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import i18n from "i18n";
import { NotesComponent } from "pages/Cockpit/CockpitTabInfo/Notes";
import { getIntentLabel, handleSpecialDisplayDate } from "./utilities";
import { getConvItemSelector } from "redux/selectors/cockpitSelectors";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@material-ui/core";
import { infoMsg } from "redux/reducers/snackMsgsReducers";
import { getMesssageItemSelector } from "redux/selectors/cockpitSelectors";
import { useTheme } from "../theme";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	root: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		marginBottom: "10px",
		borderRadius: "15%"
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: "33.33%",
		flexShrink: 0
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: "black"
	},
	AccordionDetails: {
		marginBottom: "10px"
	}
}));

export default function HistoricList({ minimalWidth, call, ...props }) {
	const classes = useStyles();
	const [expanded, setExpanded] = React.useState(false);
	const dispatch = useDispatch();
	const { isDarkMode } = useTheme();
	const muiTheme = useMuiTheme();
	const darkBg = muiTheme.palette.background.paper;

	const { userLanguage, dateFormat } = useSelector(getConvItemSelector, shallowEqual);

	const aConfig = useSelector(getMesssageItemSelector, shallowEqual);
	const intents = aConfig?.intents ?? [];

	const handleChange = panel => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	let conversation = props.conversation;
	let header = conversation?.header;
	let messages = conversation?.messages || [];
	let messagesWithConvID = messages.map(obj => ({
		...obj,
		Id: conversation.id,
		note: props.Notes
	}));
	let convHistory = props.history && props.number ? props.history[props.number] : props.history[0];

	let state = header?.state || "";
	let agent =
		conversation?.agent?.name && conversation?.agent?.name !== ""
			? conversation?.agent?.name
			: conversation?.agent?.uid || "";

	let title = getIntentLabel(conversation?.meta?.cockpit?.title, intents);
	let displayState = i18n.t(`HISTORY.${state}`);

	const computeDateHistory = header => {
		if (header.datetime) {
			return header.datetime.substring(0, 16);
		} else if (header?.dateCreated?.datetime) {
			return header.dateCreated.datetime.substring(0, 16);
		} else if (header?.dateReceived?.datetime) {
			return header.dateReceived.datetime.substring(0, 16);
		} else {
			return "";
		}
	};

	return (
		<Box data-component-name="HistoricList">
			<Accordion
				className={classes.root}
				TransitionProps={{ unmountOnExit: true }}
				expanded={expanded === "panel1"}
				onChange={handleChange("panel1")}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1bh-content"
					id="panel1bh-header"
				>
					<Grid container spacing={1} alignItems="center" wrap="wrap">
						<Grid item xs={12} sm={6} md={4} zeroMinWidth>
							{convHistory && header && (
								<ChannelUserInfoMembershipDisplayer
									convHistory={convHistory}
									channelImage={conversation?.meta?.cockpit?.channelCode || ""}
									contactNameOrEmail={conversation?.meta?.cockpit?.contact || ""}
									connected={conversation?.meta?.cockpit?.connected || false}
									FRU={conversation?.contact?.uid}
									channel={header.channel}
									fID={header.fID}
									assistantID={header.assistantID}
								/>
							)}
							<Box display="flex" flexDirection="column" width="100%" minWidth={0}>
								{convHistory !== undefined && (
									<Box
										style={{
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap"
										}}
									>
										{title && title !== "" && `${title} `}
									</Box>
								)}
								{convHistory !== undefined && (
									<Tooltip title={i18n.t("COC.CopyToClipboard")} placement="top">
										<Box
											onClick={event => {
												event.stopPropagation();
												navigator.clipboard.writeText(header.fID);
												dispatch(infoMsg(i18n.t("COC.CopyToClipboard")));
											}}
											onFocus={event => event.stopPropagation()}
											style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
										>
											{header?.fID ? `${header.fID} ` : ""}
										</Box>
									</Tooltip>
								)}
								{convHistory !== undefined && (
									<Box
										style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
									>
										{displayState ? ` ${displayState}` : ""} {agent && agent !== "" && `- ${agent}`}
									</Box>
								)}
							</Box>
						</Grid>
						<Grid item xs={12} sm={4} md={4} zeroMinWidth>
							{messagesWithConvID && (
								<Box
									textAlign="center"
									style={{
										width: "100%",
										overflow: "hidden",
										textOverflow: "ellipsis",
										whiteSpace: "nowrap"
									}}
								>
									{convHistory.meta?.cockpit?.ts
										? handleSpecialDisplayDate(
												convHistory.meta?.cockpit.ts,
												dateFormat,
												userLanguage
											)
										: convHistory?.meta?.cockpit?.datetime
											? convHistory?.meta?.cockpit?.datetime.substring(0, 16)
											: messagesWithConvID?.[0]?.header
												? computeDateHistory(messagesWithConvID?.[0]?.header)
												: ""}
								</Box>
							)}
							{messagesWithConvID?.[0]?.header &&
								messagesWithConvID?.[0]?.header.ticket &&
								messagesWithConvID?.[0]?.header.ticket !== "" && (
									<Box
										style={{
											width: "100%",
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap"
										}}
										textAlign="center"
									>
										{messagesWithConvID[0] &&
											messagesWithConvID[0].body &&
											messagesWithConvID[0].body.topic}
									</Box>
								)}
						</Grid>
						<Grid
							item
							xs={12}
							sm={2}
							md={4}
							container
							justifyContent="flex-end"
							alignItems="center"
							spacing={1}
							wrap="nowrap"
						>
							{messages && messages[lod_.findLastIndex(messages, "body.attachments[0].size")] && (
								<AttachFileOutlinedIcon />
							)}
							{props.history[props.number] !== undefined &&
								props.history[props.number].notes &&
								props.history[props.number].notes.length !== 0 && (
									<NoteOutlinedIcon style={{ transform: "rotate(270deg)" }} />
								)}
						</Grid>
					</Grid>
				</AccordionSummary>
				<AccordionDetails className={classes.AccordionDetails}>
					{conversation.header.type === "call" ? (
						<>
							{!lod_.isNil(conversation?.meta?.cockpit?.summary) &&
							!lod_.isEmpty(conversation?.meta?.cockpit?.summary) ? (
								<Box color={isDarkMode ? "var(--dark-text-secondary)" : "inherit"}>
									{conversation.meta.cockpit.summary}
								</Box>
							) : (
								<>
									{!lod_.isEmpty(conversation.Notes) ? (
										<Box bgcolor={isDarkMode ? "var(--dark-bg-elevated)" : "#c7c9c9"}>
											<NotesComponent notes={conversation.Notes} />
										</Box>
									) : (
										<Box
											bgcolor={isDarkMode ? "var(--dark-bg-elevated)" : "#c7c9c9"}
											height="100%"
											display="flex"
											justifyContent="center"
											alignItems="center"
											fontStyle="italic"
											color={isDarkMode ? "var(--dark-text-secondary)" : "inherit"}
										>
											{i18n.t("COC.emptyNotesSummary")}
										</Box>
									)}
								</>
							)}
						</>
					) : (
						<Box>
							{!lod_.isNil(conversation?.meta?.cockpit?.summary) &&
								!lod_.isEmpty(conversation?.meta?.cockpit?.summary) && (
									<Box pb={1}>{conversation.meta.cockpit.summary}</Box>
								)}
							{messagesWithConvID.map((mess, index) => (
								<Box key={`accordionHistoric${index}`} bgcolor={isDarkMode ? darkBg : "#c7c9c9"}>
									<MessageItem
										key={`$historic-message} -${index} `}
										message={mess}
										msgIndex={index}
										fromHistoric={true}
										convHistory={convHistory}
									/>
								</Box>
							))}
						</Box>
					)}
				</AccordionDetails>
			</Accordion>
		</Box>
	);
}
